import React, { useState,useEffect, useMemo, memo  } from 'react';
import TemplateDemo from '../../Assets/images/templatedemo.png'
import AddArrow from '../../Assets/images/add.svg'
import { Modal } from 'antd';
import Dashboard from '../../Assets/images/dashboard-black.svg';
import { get,post } from '../../Services/Api';
import { notification,  Checkbox  } from 'antd';
import { useNavigate } from 'react-router-dom';
import SearchIconImg from '../../Assets/images/search.svg';
import DeleteImg from '../../Assets/images/delete-black.svg';
import debounce from "lodash.debounce"; 
import AdminSidebar from '../../Components/AdminSidebar';


const Templates = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);
    const [admin_id, setAdminId] = useState(localStorage.getItem("adminId"));
    const [templateList, setTemplateList] = useState([]);
    const [templatejsonData,settemplatejsonData] =useState([]);
    const [selectedTemplates, setSelectedTemplates] = useState([]);
    const [templateSearchquery,settemplateSearchquery] = useState("");



    const navigate = useNavigate();

    useEffect(() => {
        const storedAdminId = localStorage.getItem("adminId"); // Retrieve admin_id from localStorage
        setAdminId(storedAdminId); // Store it in state
      }, []);


      useEffect(() => {
        if (!admin_id) return;
        fetchTemplateList();
      }, [admin_id]);
    
      // Fetch templates from API
      const fetchTemplateList = async () => {
        try {
          const response = await get(`listtemplates?admin_id=${admin_id}`);
          if (response?.status === 200) {
            setTemplateList(response.data);
          } else {
            throw new Error("Invalid API response");
          }
        } catch (error) {
          console.error("Error fetching templates:", error);
          notification.error({
            message: "Error Fetching Templates",
            description: "Unable to fetch templates. Please try again later.",
          });
        }
      };

    // useEffect(()=>{
    //     if (admin_id) {
    //     const fetchTemplates = async () => {
    //         try {
    //             const response = await get(`listtemplates?admin_id=${admin_id}`);

    //             // Check if response is valid
    //             if (response && response.status === 200 && response.data) {
    //                 setTemplateList(response.data); // Update state with API data
                    
                    
                   
    //             } else {
    //                 throw new Error('Invalid API response');
    //             }

    //         }catch (error) {
    //             console.error("Error fetching templates:", error);

    //             // Show error notification
    //             notification.error({
    //                 message: 'Error Fetching Templates',
    //                 description: 'There was an error fetching the templates. Please try again later.',
    //             });
    //         }
    //     };

    //     fetchTemplates();
    // }

    // },[admin_id])

    

    const handleDeleteTemplate = async (templateId) =>{

        try {
            const response = await post(`deletetemplate/${templateId}` );
            if (response?.status === 200) {
            // Show success notification
            notification.success({
                message: 'Template Deleted Successfully',
                description: '',
            });
            fetchTemplateList(); 
        } else {
            notification.error({
                message: 'Error Deleting Template',
                description: 'There was an error while deleting the template. Please try again.',
            });
        }
            
        } catch (error) {
            console.error("Error deleting data:", error);
        }
    }

    const handleCheckingTemplate = (templateId,isChecked)=>{
        setSelectedTemplates((prev)=>{
            if(isChecked){
                return [...prev,templateId]
            }else{
                return prev.filter((id)=>id !== templateId)
            }
        })
    }

    const handleMultipleDelete = async ()=>{
        if (selectedTemplates.length === 0) {
            notification.warning({
              message: 'No Templates Selected',
              description: 'Please select templates to delete.',
            });
            return;
          }
        
          try {
            const response = await post('multipledeletetemplate', {
              template_ids: selectedTemplates,
            });
        
            if (response.status === 200) {
              notification.success({
                message: 'Templates Deleted Successfully',
              });
        
              // Remove deleted templates from the list
              setTemplateList((prevList) =>
                prevList.filter((template) => !selectedTemplates.includes(template.template_id))
              );
        
              // Clear selection
              setSelectedTemplates([]);
              fetchTemplateList(); 
            } else {
              throw new Error('Failed to delete templates');
            }
          } catch (error) {
            console.error('Error deleting templates:', error);
            notification.error({
              message: 'Error Deleting Templates',
              description: 'An error occurred while deleting the templates.',
            });
          }
        
    }

    const handleTemplateSearch = debounce((query) => {
        settemplateSearchquery(query);
      },300);

        // Filter templates based on search query
//   const filteredTemplates = templateList.filter((template) =>
//     template.template_name.toLowerCase().includes(templateSearchquery.toLowerCase())
//   );


console.log("templateList::",templateList);


  const filteredTemplates = useMemo(()=>{
    if (!templateSearchquery) return templateList;
    return templateList.filter((template) =>template.template_name.toLowerCase().includes(templateSearchquery.toLowerCase())
    );
  },[[templateList, templateSearchquery]])

  console.log("filteredTemplates::",filteredTemplates);
  

    const handleImageClick = (imageSrc) => {
        setCurrentImage(imageSrc);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setCurrentImage(null);
    };

    const handleTemplateLoad = async  (templateUniqueKey)=>{
        console.log("templateList For checking on loading template::",templateList);
        if (!Array.isArray(templateList)) {
            console.error("templateList is not an array or is undefined.");
            return;
        }

        const matchedTemplateId = templateList.find((templateId)=>templateId.template_id === templateUniqueKey)

        console.log("matchedTemplateId.template_json::",matchedTemplateId.template_json);
        

        console.log("matchedTemplateId::",matchedTemplateId);
        const  payload= {
            admin_id: admin_id,
            template_name: matchedTemplateId.template_name,
            template_json: matchedTemplateId.template_json
        }
        // matchedTemplateId.template_json

        console.log("Selecting Saved template payload::",payload);
        
        if (payload)
        {
            // settemplatejsonData(matchedTemplateId.template_json) 

            try{

            // const graphDemandResponse = await post('graphdemandlatest',matchedTemplateId.template_json)
            // const graphDemandResponse = await post('http://192.168.96.120:5000/apis/templategraphdemandlatestdb',payload)
            const graphDemandResponse = await post('templategraphdemandlatestdb',payload)

            // const overviewGraphDemandResponse = await post('overviewgraphdemand',matchedTemplateId.template_json);
            // const overviewGraphDemandResponse = await post('http://192.168.96.120:5000/apis/templateoverviewgraphdemanddb',payload);
            const overviewGraphDemandResponse = await post('templateoverviewgraphdemanddb',payload);

            navigate('/dashboard', 
                { state: { 
                    // selectedValues: selectedValues,
                    parkingDemandData: graphDemandResponse.data,
                    overviewGraphDemandData: overviewGraphDemandResponse.data,
                 } });
            }catch(error){
                notification.error({
                    message: 'Error Loading Template Data',
                    description: 'Failed to fetch graph demand data. Please try again later.',
                });
            }
        }


    }
    
    return (
        <div className="row">
            <div className="d-flex align-items-center">
            <AdminSidebar />
            <div className="col-size-8">
                <div className="inside-filter">

                <div className="col-lg-12">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                    <h4>
                    Saved Templates
                    </h4>
                    
                    </div>
                    <div className="d-flex align-items-center ">
                        {selectedTemplates.length > 1 &&(
                        <div className="template-delete">
                        <a 
                        href="#"
                        onClick={(e)=>{
                            e.preventDefault();
                            handleMultipleDelete()
                        }
                        }
                        >
                            <img src={DeleteImg} alt="" />
                        </a>
                        </div>
                        )}

                        {templateList.length>0 &&(

                        <div className="my-2 d-flex align-items-center position-relative ms-3">        
                            <input type="search"  
                            className="form-control pe-5" 
                            onChange={(e)=>{
                                e.preventDefault()
                                handleTemplateSearch(e.target.value)
                            }}
                            placeholder="search" />
                            <span className="position-absolute top-4" style={{right: '10px'}}>
                            <img src={SearchIconImg} alt="" style={{width: '18px'}} />
                            </span>
                        </div>
                         )} 
                    </div>
                </div>
               
            </div>
            <div className="row">
            <div className="col-lg-3 mb-3 resize-col-lg-3">
                <div className="card-inside text-center" style={{
                    boxShadow: '-1px 1px 4px 0px #0000000D',
                    border: '1px dashed rgb(191, 191, 191)'
                }}>
                    <a href="/spaceSelect/planning-to-theater" style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <div>
                            <img src={AddArrow} alt="" style={{ width: '20px' }} className="mb-2" />
                            <h4 className="view-dashboard m-auto" style={{ fontSize: '14px', width: 'fit-content', color: '#000', borderColor: '#E6ECEF' }}>Add New Template</h4>
                        </div>
                    </a>
                </div>
            </div>
            {/* {templateList.map((template) => ( */}
            {filteredTemplates.map((template) => (
                <div key={template.template_id} className="col-lg-3 mb-3 resize-col-lg-3">
                    <div className="card-inside text-left p-0">
                        <a
                            href="#"
                            className="template-img"
                            onClick={(e) => {
                                e.preventDefault();
                                // handleImageClick(template.image);
                                handleTemplateLoad(template.template_id)
                            }}
                        >
                            <img src={TemplateDemo} alt="" className="w-100" />
                        </a>
                        <div className="d-flex align-items-center justify-content-between p-3 content-wrap-style">
                            <div className="d-flex align-items-center me-2">
                                <Checkbox 
                                onChange={(e)=>{
                                    handleCheckingTemplate(template.template_id,e.target.checked)
                                }} 
                                checked={selectedTemplates.includes(template.template_id)}
                                className="me-2" />
                                <div className="content-temp">     
                                  <h6 
                                  className="mb-0 name-template"
                                  style={{ textTransform: "none" }}
                                  >{template.template_name}</h6>
                                  {/* <p className="mb-0">
                                      Updated 1 month ago
                                  </p> */}
                                </div>
                            </div>
                           <div className="d-flex align-items-center wrap-div">
                           <a href="#" 
                           className="view-dashboard me-2"
                           onClick={(e) => {
                            e.preventDefault();
                            // handleImageClick(template.image);
                            handleTemplateLoad(template.template_id)
                        }}
                           >
                                <img src={Dashboard} alt="" style={{ width: '18px' }} /> 
                            </a>
                            <a href="#" className="view-dashboard">
                                <img 
                                src={DeleteImg} 
                                alt=""
                                onClick={(e)=>{
                                    e.preventDefault()
                                    handleDeleteTemplate(template.template_id)}}
                                style={{ width: '18px' }} /> 
                            </a>
                           </div>
                           
                        </div>
                    </div>
                </div>
            ))}

            {/* Add new card */}
           

            {/* Modal for image preview */}
            <Modal
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={null}
                width="auto"
                centered
            >
                <img src={currentImage} alt="Template Preview" style={{ width: '100%' }} />
            </Modal>
            </div>
            </div>
            </div>
        </div>
        </div>
    )
}

export default Templates;

